export default {
  background: '#e04034',
  primary: '#000',
}